import { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { RequireAuth } from "@/routes/RequireAuth";
import { RequirePermission } from "@/routes/RequirePermission";
import { RedirectIfAuthenticated } from "@/routes/RedirectIfAuthenticated";
import { AppLayout } from "@/components/layout/AppLayout";
import { LoginPage } from "@/pages/LoginPage";
import { DashboardPage } from "@/pages/DashboardPage";
const SignalsPage = lazy(() => import("@/pages/SignalsPage").then(({ SignalsPage }) => ({ default: SignalsPage })));
const StrategiesPage = lazy(() => import("@/pages/StrategiesPage").then(({ StrategiesPage }) => ({ default: StrategiesPage })));
const ResearchPage = lazy(() => import("@/pages/ResearchPage").then(({ ResearchPage }) => ({ default: ResearchPage })));
const AccountPage = lazy(() => import("@/pages/AccountPage").then(({ AccountPage }) => ({ default: AccountPage })));
const SettingsPage = lazy(() => import("@/pages/SettingsPage").then(({ SettingsPage }) => ({ default: SettingsPage })));
const ProfilePage = lazy(() => import("@/pages/ProfilePage").then(({ ProfilePage }) => ({ default: ProfilePage })));
import { NotFoundPage } from "@/pages/NotFoundPage";
import { AdminLayout } from "@/features/admin/AdminLayout";
import { FullScreenLoader } from "@/components/feedback/FullScreenLoader";

const AdminRoutes = lazy(() => import("@/app/AdminRoutes").then(({ AdminRoutes }) => ({ default: AdminRoutes })));

function AdminLoading() {
  return <FullScreenLoader message="Loading admin workspace…" />;
}

function RouteLoading() {
  return <FullScreenLoader message="Loading workspace…" />;
}

export function AppRouter() {
  return <Routes>
    <Route path="/" element={<Navigate to="/dashboard" replace />} />
    <Route path="/login" element={<RedirectIfAuthenticated><LoginPage /></RedirectIfAuthenticated>} />
    <Route element={<RequireAuth><AppLayout /></RequireAuth>}>
      <Route path="/dashboard" element={<DashboardPage />} />
      <Route path="/signals" element={<RequirePermission permission="signals:read"><Suspense fallback={<RouteLoading />}><SignalsPage /></Suspense></RequirePermission>} />
      <Route path="/strategies" element={<RequirePermission permission="strategies:read"><Suspense fallback={<RouteLoading />}><StrategiesPage /></Suspense></RequirePermission>} />
      <Route path="/research" element={<RequirePermission permission="strategies:read"><Suspense fallback={<RouteLoading />}><ResearchPage /></Suspense></RequirePermission>} />
      <Route path="/account" element={<Suspense fallback={<RouteLoading />}><AccountPage /></Suspense>} />
      <Route path="/profile" element={<Suspense fallback={<RouteLoading />}><ProfilePage /></Suspense>} />
      <Route path="/settings" element={<RequirePermission permission="settings:manage"><Suspense fallback={<RouteLoading />}><SettingsPage /></Suspense></RequirePermission>} />
    </Route>
    <Route path="/admin/*" element={<RequireAuth><RequirePermission permission="admin:read"><AdminLayout /></RequirePermission></RequireAuth>}>
      <Route path="*" element={<Suspense fallback={<AdminLoading />}><AdminRoutes /></Suspense>} />
    </Route>
    <Route path="*" element={<NotFoundPage />} />
  </Routes>;
}
